// sectors of the "Information Media and Telecommunication" (id: 555bb0e425a9732ca20a3355) industry
export const sectorOptions = [
  {
    "name": "Computer System Design and Related Services",
    "id": "555c6bd38af667b6bbf11041",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Data Processing, Web Hosting and Electronic Information Storage Services",
    "id": "555c6bd38af667b6bbf11047",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Internet Publishing and Broadcasting",
    "id": "555c6bd38af667b6bbf11085",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Internet Service Providers and Web Search Portals",
    "id": "555c6bd38af667b6bbf11086",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Libraries and Archives",
    "id": "555c6bd38af667b6bbf11093",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Motion Picture and Video Activities",
    "id": "555c6bd38af667b6bbf11105",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Newspaper, Periodical, Book and Directory Publishing",
    "id": "555c6bd38af667b6bbf11114",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Other Information Services",
    "id": "555c6bd38af667b6bbf11131",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Radio Broadcasting",
    "id": "555c6bd38af667b6bbf11167",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Software Publishing",
    "id": "555c6bd38af667b6bbf11186",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Sound Recording and Music Publishing",
    "id": "555c6bd38af667b6bbf11187",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Telecommunications Services",
    "id": "555c6bd38af667b6bbf11196",
    "industryId": "555bb0e425a9732ca20a3355"
  }, {
    "name": "Television Broadcasting",
    "id": "555c6bd38af667b6bbf11197",
    "industryId": "555bb0e425a9732ca20a3355"
  }
];